import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BarPosition, ProgressStyles, ProgressValues } from './progress-step-indicator';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pc-progress-step-indicator',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './progress-step-indicator.component.html',
  styleUrl: './progress-step-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressStepIndicatorComponent {
  public progress = input.required<ProgressValues>();
  public position = input.required<BarPosition>();
  public stepName = input.required<string>();
  public isClickable = input.required<boolean>();
  public isAnimated = input.required<boolean>();
  public progressRadius = computed<Record<string, boolean>>(() => this.setProgressRadius());
  public progressStyle = computed<Record<string, string>>(() => this.setProgressStyle());
  public progressMarginAndCursor = computed<Record<string, boolean>>(() => this.setProgressMarginAndCursor());
  public progressColorAndRadius = computed<Record<string, boolean>>(() => this.setProgressColorAndRadius());

  private setProgressRadius(): Record<string, boolean> {
    return {
      [ProgressStyles.borderRadiusStart]: this.position() === BarPosition.Start,
      [ProgressStyles.borderRadiusEnd]: this.position() === BarPosition.End,
      [ProgressStyles.borderRadiusMiddle]: this.position() === BarPosition.Middle
    };
  }

  private setProgressColorAndRadius(): Record<string, boolean> {
    return {
      [ProgressStyles.borderRadiusStart]: this.position() === BarPosition.Start,
      [ProgressStyles.borderRadiusEnd]: this.position() === BarPosition.End,
      [ProgressStyles.borderRadiusMiddle]: this.position() === BarPosition.Middle,
      [ProgressStyles.redBackground]: this.progress() !== ProgressValues.Zero,
      [ProgressStyles.greyBackground]: this.progress() === ProgressValues.Zero
    };
  }

  private setProgressStyle(): Record<string, string> {
    return {
      width: `${this.progress()}%`,
      transition: this.isAnimated() ? 'width 1s' : ''
    };
  }

  private setProgressMarginAndCursor(): Record<string, boolean> {
    return {
      [ProgressStyles.progressMargin]: this.position() !== BarPosition.End,
      [ProgressStyles.pointerCursor]: this.isClickable()
    };
  }
}
